export default __webpack_public_path__ + "static/bannerabout-11ef70ec926b4a0b59b7d106812c0e0f.png";